
module.exports = {

    // 头部菜单
    common: {
        login: 'sign up',
        register:'register',
        reset:'reset',
        app:'Click to download the sugar detection APP',
        admin:'Zhengtu sugar detection system',
        title:'Chengdu Zhengtu Technology',
        smxz:'Scan code to download',
        logout:'logout',
        search:'search',
        add:'new',
        password:'Forgot password'
    },
}
